import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Container = props => {
  const { className, fluid, ...attributes } = props;

  const classes = classNames(className, fluid ? 'container-fluid' : 'container');

  return <div {...attributes} className={classes} />;
};

Container.propTypes = {
  fluid: PropTypes.bool,
  className: PropTypes.string,
  cssModule: PropTypes.object,
};

export default Container;
